import React, { JSX } from "react";
import { Container } from "./GradientFrame.styled";

export type GradientFrameProps = {} & React.ComponentProps<typeof Container>;

export const GradientFrame: React.FC<GradientFrameProps> = (props): JSX.Element => {
  return <Container {...props} />;
};
